import { MaxFileSizeIndicator } from "@/components/common/Uploader/MaxFileSizeIndicator/MaxFileSizeIndicator";
import { AddIcon } from "components/common/Icons/AddIcon";
import { LandscapeIcon } from "components/common/Icons/LandscapeIcon";
import { Translate } from "components/common/Translate/Translate";
import { useNoImages } from "./useNoImages";

export const NoImages = () => {
    const { dragUploadRef, isDragging, handleDeviceUploadClick } = useNoImages();

    return (
        <div data-testid="no-images-container">
            <div className="capitalize">
                <Translate keyName="upload-images-to-compress" />
            </div>

            <div
                className={`group cursor-pointer border ${
                    isDragging ? "border-white" : "border-irGray-400 dark:border-darkSurface-600"
                } hover:border-irGray-600 dark:hover:border-darkSurface-500 border-dashed py-20 w-full mt-8 flex flex-col items-center justify-center gap-4 ${
                    isDragging && "bg-irBlue-200"
                }`}
                ref={dragUploadRef}
                onClick={handleDeviceUploadClick}
                data-testid="no-images-file-upload"
            >
                {isDragging ? (
                    <div>
                        <LandscapeIcon />
                    </div>
                ) : (
                    <>
                        <AddIcon className="fill-irGray-500 group-hover:fill-irGray-600 dark:fill-white dark:group-hover:fill-white" />

                        <div>
                            <Translate keyName="drag-and-drop-images-here" />
                        </div>
                        <div className="text-sm [&_a]:text-blue-500">
                            <MaxFileSizeIndicator />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
